import React from 'react';
// TODO remove this route for unauth users
const Welcome = React.lazy(() => import('./views/Welcome/Welcome'));
const paymentConfirmation = React.lazy(() =>
    import('./views/Payments/PaymentConfirmation/PaymentConfirmation'));
const noConnection = React.lazy(() =>
    import('./views/Pages/noConnection'));
const RedirectTest = React.lazy(() =>
    import('./RedirectTest'));
const paymentMethod = React.lazy(() => import('./views/Payments/PaymentMethod/PaymentMethod'));
const paymentInformation = React.lazy(() =>
    import('./views/Payments/PaymentInformation/PaymentInformation'));

const Parameters = React.lazy(() =>
    import('./views/Admin/Parameters/Parameters'));
const paymentRetry = React.lazy(() =>
    import('./views/Payments/PaymentRetry/PaymentRetry'));
const Login = React.lazy(() => import('./views/Admin/Login/Login'));
const CallBack = React.lazy(() =>
    import('./views/Admin/Login/Callback/CallBack'));
const routes = [
  { path: '/', exact: true, name: '', component: Welcome },
  //ADMIN
  { path: '/admin/login', exact: true, name: '', component: Login },
  { path: '/admin/callback', exact: true, name: 'Callback Page', component: CallBack },

  { path: '/paymentstatus', exact: true, name: '', component: paymentConfirmation },
  { path: '/payment/method', exact: true, name: '', component: paymentMethod },
  { path: '/payment/info', exact: true, name: '', component: paymentInformation},
  { path: '/paymentstatus', exact: true, name: '', component: paymentConfirmation },
  { path: '/noconnection', exact: true, name: '', component: noConnection },
  { path: '/redirect', exact: true, name: '', component: RedirectTest},
  { path: '/payment/retry', exact: true, name: '', component: paymentRetry},
];

export default routes;

